import { useMemo } from 'react'
import type { User } from 'firebase/auth'
import { useSetPosts, type SetFeed } from './useSetPosts'
import { useGuestGuard } from './useGuestGuard'
import { postToFeedPrompt } from '../lib/guestPrompts'
import type { Group, Set as FestivalSet } from '../types'

/** An event's set feed, bundled for the schedule/lineup with the guest sign-up wall on posting. */
export function useSetFeed(
  eventId: string,
  user: User | null,
  groups: Group[],
  linkedGroups: Group[],
  friendIds: string[],
  sets: FestivalSet[],
): SetFeed {
  const { postsBySet, postsByArtist, allPosts, summaryBySet, summaryByArtist, createPost, deletePost } =
    useSetPosts(eventId, user, groups, linkedGroups, friendIds, sets)
  const { isGuest, prompt } = useGuestGuard()
  return useMemo<SetFeed>(
    () => ({
      postsBySet,
      postsByArtist,
      allPosts,
      summaryBySet,
      summaryByArtist,
      createPost,
      deletePost,
      groups,
      isGuest,
      onRequireAuth: () => prompt(postToFeedPrompt()),
    }),
    [postsBySet, postsByArtist, allPosts, summaryBySet, summaryByArtist, createPost, deletePost, groups, isGuest, prompt],
  )
}
